import { postReq } from './api';

export const uploadImage = async ({
  accessToken,
  folder,
  uploadPreset,
  file,
}: {
  accessToken: string;
  folder: string;
  uploadPreset?: string;
  file: File;
}): Promise<{ data?: {secure_url: string}; error?: any }> => {
  const formData = new FormData();
  formData.append('folder', folder);
  formData.append('file', file);
  if (uploadPreset) {
    formData.append('upload_preset', uploadPreset);
  }

  return await postReq(
    '/image_upload',
    accessToken,
    formData,
    'Failed to upload image.',
    'form-data'
  );
};
